module.exports = __webpack_public_path__ + "img/discount_off.d718e003.svg";